module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-inverse-pastelgolden-icon.47f82454.svg";